// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ea-0";
export var fileCarousel = "_ea-2";
export var removeFileButton = "_ea-1";